// src/components/Terms.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Terms() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div style={pageStyle}>
      {/* Bandeau en haut */}
      <div style={headerStyle}>
        <span style={logoStyle} onClick={() => navigate("/")} role="button">
          Dansy
        </span>
        <h1 style={titleStyle}>Mentions légales</h1>
      </div>

      {/* Contenu principal */}
      <div style={contentContainerStyle} data-aos="fade-up">
        <section>
          <h2 style={sectionTitleStyle}>1. Objet</h2>
          <p style={paragraphStyle}>
            Les présentes conditions générales d'utilisation (ci-après « Conditions ») régissent l'accès et l'utilisation du site Dansy, mis à disposition par [Nom de la société/organisme]. En utilisant ce site, vous acceptez ces Conditions dans leur intégralité. Si vous n'acceptez pas ces Conditions, veuillez ne pas utiliser le site.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>2. Accès au service</h2>
          <p style={paragraphStyle}>
            L'accès au site est gratuit et ouvert à tous. Toutefois, Dansy se réserve le droit de modifier ou de suspendre, temporairement ou définitivement, l'accès à tout ou partie du site, sans préavis.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>3. Obligations de l'utilisateur</h2>
          <p style={paragraphStyle}>
            L'utilisateur s'engage à utiliser le site dans le respect des lois en vigueur et à ne pas perturber son fonctionnement. Toute utilisation abusive ou non autorisée pourra faire l'objet de poursuites judiciaires.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>4. Propriété intellectuelle</h2>
          <p style={paragraphStyle}>
            Tous les contenus présents sur le site (textes, images, logos, etc.) sont protégés par des droits de propriété intellectuelle. Toute reproduction, modification ou diffusion sans autorisation préalable est interdite.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>5. Limitation de responsabilité</h2>
          <p style={paragraphStyle}>
            Dansy ne saurait être tenu responsable des dommages directs ou indirects résultant de l'accès ou de l'utilisation du site. L'utilisateur est seul responsable de l'utilisation qu'il fait des informations fournies.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>6. Modifications des conditions</h2>
          <p style={paragraphStyle}>
            Nous nous réservons le droit de modifier à tout moment les présentes Conditions. Les modifications prendront effet dès leur publication sur le site. Il est conseillé de consulter régulièrement cette page pour prendre connaissance des éventuelles mises à jour.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>7. Loi applicable et juridiction compétente</h2>
          <p style={paragraphStyle}>
            Les présentes Conditions sont régies par la loi française. Tout litige relatif à leur interprétation ou à leur exécution sera de la compétence exclusive des tribunaux français.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>8. Contact</h2>
          <p style={paragraphStyle}>
            Pour toute question ou demande d'information concernant ces Conditions, veuillez nous contacter à l'adresse suivante : contact@dansy.com.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>9. Acceptation des conditions</h2>
          <p style={paragraphStyle}>
            En accédant et en utilisant le site, vous déclarez avoir lu, compris et accepté sans réserve l'intégralité des présentes Conditions d'utilisation.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>10. Responsabilités</h2>
          <p style={paragraphStyle}>
            L'utilisateur est seul responsable de ses actions sur le site. Dansy décline toute responsabilité en cas de dommages directs ou indirects causés par l'utilisation ou l'incapacité à utiliser le site, y compris les pertes de données.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>11. Durée et résiliation</h2>
          <p style={paragraphStyle}>
            Les présentes Conditions entrent en vigueur dès la première utilisation du site et restent applicables jusqu'à leur résiliation par l'une des parties. Dansy se réserve le droit de suspendre ou de résilier l'accès au site à tout utilisateur en cas de non-respect des présentes conditions.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>12. Force majeure</h2>
          <p style={paragraphStyle}>
            Dansy ne pourra être tenu responsable en cas d'inexécution partielle ou totale de ses obligations, si cette inexécution est due à un événement de force majeure tel qu'une catastrophe naturelle, un conflit armé ou toute autre circonstance échappant au contrôle raisonnable de Dansy.
          </p>
        </section>
      </div>
    </div>
  );
}

/* =================== STYLES =================== */

const pageStyle = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  overflowX: "hidden",
  position: "relative",
  minHeight: "100vh",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: "60px" // ajout d'un padding pour éviter que le contenu ne se cache derrière le header
};

const headerStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #fff0f3, #ffd6dd)",
  color: "#000",
  padding: "15px",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  height: "50px", // hauteur du header (augmentée pour une meilleure lisibilité)
  zIndex: 100,
};

const logoStyle = {
  position: "absolute",
  left: "20px",
  fontSize: "1.7rem",
  fontFamily: "'Shirkhand', cursive",
  color: "#ff477e",
  fontWeight: "bold",
  cursor: "pointer",
};

const titleStyle = {
  fontSize: "1.5rem",
  fontWeight: 700,
};

const contentContainerStyle = {
  marginTop: "100px", // espace entre le header et le contenu
  backgroundColor: "#fff",
  borderRadius: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  padding: "30px",
  textAlign: "left",
  maxWidth: "800px",
  width: "90%",
  marginBottom: "40px",
};

const sectionTitleStyle = {
  fontSize: "1.8rem",
  color: "#333",
  margin: "20px 0 10px",
};

const paragraphStyle = {
  fontSize: "1rem",
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "15px",
};
